import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import GuideLayout from "./GuideLayout";

const GuideIndex = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "gf-guide-index-jsonld";
    script.type = "application/ld+json";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "GitHub Finder guides",
      description:
        "How-to guides for discovering GitHub developers and repositories with practical search and filter workflows.",
      url: "https://githubfinder.adnwebs.com/guide",
    });
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById("gf-guide-index-jsonld");
      if (el) el.remove();
    };
  }, []);

  const cards = [
    {
      to: "/guide/find-github-developers",
      title: "Find GitHub developers",
      text:
        "Intent, keywords, location, and advanced filters—build a repeatable workflow for talent discovery and research.",
    },
    {
      to: "/guide/search-github-repositories",
      title: "Search GitHub repositories",
      text:
        "Use repository mode, read repo cards, sort results, and open details—aligned with how teams evaluate open source.",
    },
    {
      to: "/guide/faq",
      title: "FAQ",
      text:
        "Skill and location search, repository coverage, and practical usage questions.",
    },
  ];

  return (
    <GuideLayout
      title="Guides & how-tos"
      description="Structured workflows for discovering developers and repositories on GitHub—beyond random browsing."
      eyebrow="Resources"
      wide
      breadcrumb={[
        { to: "/", label: "Home" },
        { label: "Guides" },
      ]}
    >
      <div className="gf-guide-index">
        <p className="gf-guide-lead">
          Whether you are recruiting, auditing dependencies, or comparing portfolios, these guides explain how this app
          maps real GitHub search behaviour to a clear UI: filters, results, and optional profile insights.
        </p>
        <ul className="gf-guide-cards">
          {cards.map((c) => (
            <li key={c.to}>
              <Link to={c.to} className="gf-guide-cards__link">
                <h2 className="gf-guide-cards__title">{c.title}</h2>
                <p className="gf-guide-cards__text">{c.text}</p>
                <span className="gf-guide-cards__cta">Read guide →</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </GuideLayout>
  );
};

export default GuideIndex;
